import React, { useState, useEffect } from 'react';
import giftIcon from "../images/Acquisition/gift-icon.svg";

const SafeImage = ({ src, alt, className = "", style = {}, fallback = giftIcon }) => {
  const [isFallback, setIsFallback] = useState(false);

  const validName = alt && alt.trim() !== "" ? alt : "No image";

  const handleError = (e) => {
    e.target.onerror = null;
    e.target.src = fallback;
    setIsFallback(true); // fallback is now used
  };

  // If initial src is invalid or empty, treat it as fallback immediately
  useEffect(() => {
    if (!src || src.trim() === "") {
      setIsFallback(true);
    }
  }, [src]);

  // Modify class/style based on fallback
  const combinedClassName = `${className} ${isFallback ? "fallback-image" : ""}`;
  const combinedStyle = {
    ...style,
    ...(isFallback ? { opacity: 0.5, objectFit: "contain" } : {}) // example fallback style
  };

  return (
    <img
      src={isFallback ? fallback : src}
      alt={validName}
      className={combinedClassName}
      onError={handleError}
      style={combinedStyle}
    />
  );
};

export default SafeImage;
